import { memo } from "react";

const SectionLabel = memo(({ children }: { children: React.ReactNode }) => (
  <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold px-4 mb-2">
    {children}
  </p>
));

export default SectionLabel;